import {
    Box,
    Paper,
    Skeleton
} from '@mui/material';
import { action, computed, observable, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import { IParametrosUsuario } from '../../modelo/Parametros';
import ParametroUsuarioService from '../../services/ParametroUsuarioService';
import MensagemStore from '../../store/MensagemStore';
import ParametroUsuarioStore from '../../store/ParametroUsuarioStore';
import TabelaParametrosUsuario from './TabelaParametrosUsuario';
import './css/ParametroSistemaStyles.css';



export interface IPropsParametroUsuario {
    parametroParaExclusao?: IParametrosUsuario;
}


class ParametroUsuario extends React.Component<IPropsParametroUsuario> {
    parametro: IParametrosUsuario;

    constructor(props: IPropsParametroUsuario) {
        super(props);

        makeObservable(this, {
            parametro: observable,
            parametros: computed,
            limpar: action,
            handleInputChange: action
        });
    }

    get parametros() {
        return ParametroUsuarioStore.parametros;
    }

    async salvarParametro() {
        try {
            if (this.parametro.numParametro) {
                await ParametroUsuarioService.salvar(this.parametro);
                MensagemStore.apresentarInformacao('Parâmetro salvo com sucesso');
                this.limpar();
            }
        } catch (error) {
            console.error('Erro ao salvar parâmetro. ', error);
            MensagemStore.apresentarErro(`Erro ao salvar parâmetro. ${error}`);
        }
    }

    limpar() {
        this.parametro = null;
    }

    handleValorChange = (event) => {
        this.handleInputChange(event, 'valor');
    }

    handleInputChange(event, nomeCampo) {
        event.preventDefault();
        this.parametro[nomeCampo] = event.target.value;
    }

    render() {
        return (
            <div className="fixa-altura">
                <div className="fixa-altura">
                    {this.renderTabelaParametros()}
                </div>
            </div>
        );
    }

    renderTabelaParametros() {
        return (
            <div className="container altura-container">
                {this.parametros !== undefined &&
                    this.parametros.length > 0 ?
                    <TabelaParametrosUsuario
                        titulo="Configuração de Colunas do Usuário"
                    />
                    :
                    this.renderSkeletonParametros()
                }
            </div>
        );
    }

    renderSkeletonParametros() {
        return (
            <Box
                role="status"
                aria-label="Carregando parâmetros do usuário"
                sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
            >
                <Paper sx={{ pt: 3, borderRadius: 0 }}>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                            gap: 1,
                            px: { xs: 1, md: 28 },
                            alignItems: 'end'
                        }}
                    >
                        {[0, 1, 2, 3].map((item) => (
                            <Skeleton key={item} variant="rounded" height={42} />
                        ))}
                    </Box>
                </Paper>

                <Paper sx={{ p: 2, flex: 1, borderRadius: 0 }}>
                    <Skeleton sx={{ mx: 'auto', mb: 3 }} width={230} height={32} />

                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', px: 1, pb: 1.5 }}>
                        <Skeleton width={50} height={24} />
                        <Skeleton width={45} height={24} />
                    </Box>

                    {[0, 1, 2, 3].map((item) => (
                        <Box
                            key={item}
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                alignItems: 'center',
                                minHeight: 110,
                                px: 1,
                                borderTop: 1,
                                borderColor: 'divider'
                            }}
                        >
                            <Skeleton width="45%" height={24} />
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                {[0, 1].map((escaninho) => (
                                    <Box key={escaninho} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Skeleton variant="rounded" width={20} height={20} />
                                        <Skeleton width={150} height={22} />
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    ))}

                    <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2, borderTop: 1, borderColor: 'divider' }}>
                        <Skeleton variant="rounded" width={82} height={36} />
                    </Box>
                </Paper>
            </Box>
        );
    }
}

export default observer(ParametroUsuario);
